import React, { FC } from 'react';
import { Box, Container } from '@material-ui/core';

import { StyledPage } from '../../../app/components/DashboardLayout/DashboardLayout.style';
import { ResetPasswordError } from '../../components/ResetPasswordError/ResetPasswordError';

export const ResetPasswordErrorView: FC = () => (
  <StyledPage title="Reset Password Error">
    <Box
      display="flex"
      flexDirection="column"
      height="100%"
      justifyContent="center"
    >
      <Container maxWidth="sm">
        <ResetPasswordError />
      </Container>
    </Box>
  </StyledPage>
);
